import { Injectable } from "@angular/core";
import { AbstractControl, AsyncValidator, ValidationErrors } from "@angular/forms";
import { TrainingProgramService } from "app/services/training/training-program.service";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";

@Injectable({ providedIn: 'root' })

export class FacilitatorLicenseIdValidator implements AsyncValidator {
  constructor(private trainingProgramService: TrainingProgramService){}

  validate(
    control: AbstractControl
  ): Observable< ValidationErrors | null > {
      const today = new Date();
      const cutoffDate = new Date('2025-09-01');
      if (today >= cutoffDate) {
        return this.trainingProgramService.checkLicenseExists(control.value).pipe(
          map(exists => (!exists ? { idNotFound: true} : null )),
          catchError(() => of(null))
        )
      }
      return of(null);
  }
}
